import { useEffect, useState } from 'react';
import MonitoringTutorialImg from '@/assets/images/MonitoringTutorial.png';

const MonitoringTutorialPage = () => {
  const [started, setStarted] = useState(false);

  // 마운트 후 프로그래스바 애니메이션 시작
  useEffect(() => {
    requestAnimationFrame(() => setStarted(true));
  }, []);

  // 1초 후 팝업 자동 닫기
  useEffect(() => {
    const timer = setTimeout(() => {
      window.close();
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="flex h-full w-full flex-col items-center justify-center bg-white p-[30px]">
      <div className="flex w-full flex-col items-center gap-[24px]">
        {/* 확장프로그램 상단 바 이미지 */}
        <div className="flex flex-col items-center gap-[10px]">
          <img
            src={MonitoringTutorialImg}
            alt="확장 프로그램 상단 바"
            className="w-full rounded-[8px] border border-gr-200"
          />
          <div className="text-center text-gr-600 Body5M14">
            상품 상단의 <span className="text-point-500">상품순위 모니터링</span> 버튼을 눌러주세요
          </div>
        </div>

        {/* 안내 문구 */}
        <div className="flex flex-col items-center gap-[6px]">
          <div className="text-gr-900 Title3S18">상품 페이지로 이동중이에요</div>
          <div className="text-center text-gr-700 Body5M14">
            상단 모니터링 버튼을 눌러주세요
          </div>
        </div>

        {/* 프로그래스바 */}
        <div className="h-[6px] w-full overflow-hidden rounded-full bg-gr-200">
          <div
            className="h-full rounded-full bg-point-500 transition-all duration-1000 ease-linear"
            style={{ width: started ? '100%' : '0%' }}
          />
        </div>
      </div>
    </div>
  );
};

export default MonitoringTutorialPage;
